import en_US from '../../date-picker/locale/en_US';
export default en_US;
//# sourceMappingURL=en_US.js.map



//////////////////
// WEBPACK FOOTER
// ../~/_antd@3.23.4@antd/es/calendar/locale/en_US.js
// module id = 317
// module chunks = 0